import React, { useContext } from 'react'
import { Nav } from 'react-bootstrap'
import { useTypedTranslation } from 'app/modules/shared/hooks/use-translation'
import { useLocation } from 'react-router'
import { CustomButtons } from './custom-buttons'
import { LanguageSelector } from './language'
import { UserButton } from './user-button/user-button'
import Search from './search-bar'
import Feed from './feed'
import { getActiveSubRouteClass } from './helpers/helpers'
import { applicationConfiguration } from 'app/modules/shared'
import { Link } from 'react-router-dom'
import { getPageUrl } from 'app/modules/shared/routing'
import AppbarLayout from '../layouts/appbar-layout'

const Appbar = () => {
  const { _t } = useTypedTranslation()
  const config = useContext(applicationConfiguration)

  const currentRoute = useLocation().pathname.substring(1)
  const getActiveClass = (activeRoutes: string[]) =>
    getActiveSubRouteClass(activeRoutes, currentRoute, 'appbar-item-selected')

  const isCommunity = config.buildType === 'community'
  const tabs = [
    { pathKey: 'reports', trans: 'reports' },
    { pathKey: 'trends', trans: 'trends', url: getPageUrl('trends', { subpage: 'overview' }) },
    { pathKey: 'advanced-search', trans: 'hunting' },
    { pathKey: 'leaders', trans: 'leader-board' },
  ]

  const extraLinks = (config.extraLinks ?? []).map((link) => (
    <Nav.Link key={link.name} className="appbar-item" href={link.url} target="_blank">
      {link.name}
    </Nav.Link>
  ))

  return (
    <AppbarLayout>
      {tabs.map(({ pathKey, trans, url }) => (
        <Link
          key={pathKey}
          className={`appbar-item nav-link ${getActiveClass([pathKey])}`}
          to={url || (getPageUrl(pathKey) as string)}
        >
          {_t(trans)}
        </Link>
      ))}
      <Nav.Link className="appbar-item" href="api/docs" target="_blank">
        {_t('api')}
      </Nav.Link>
      <Feed />
      {isCommunity ? extraLinks : null}
      <div className="my-auto appbar-divider" />
      <CustomButtons />
      <LanguageSelector />
      {/* <Notifications /> - To be added in phase 2 */}
      <UserButton />
      <Search className="hide-mobile" />
    </AppbarLayout>
  )
}

export default Appbar
